import React from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

import { formatCurrency } from "fond/utils/currency";

import { SIGNIFICANT_DIFF_ABSOLUTE, SIGNIFICANT_DIFF_PERCENT } from "./comparisonDiff";

import { LegendItem, LegendRoot, LegendSwatch, LegendTitle } from "./BomComparisonLegend.styles";

interface BomComparisonLegendProps {
  currency?: string;
}

export const BomComparisonLegend: React.FC<BomComparisonLegendProps> = ({ currency }) => (
  <LegendRoot>
    <LegendTitle>Difference vs. baseline</LegendTitle>
    <LegendItem>
      <LegendSwatch variant="increase" />
      Significant increase (≥{SIGNIFICANT_DIFF_PERCENT}% &amp; ≥{formatCurrency(SIGNIFICANT_DIFF_ABSOLUTE, { currency, notation: "compact" })})
    </LegendItem>
    <LegendItem>
      <LegendSwatch variant="decrease" />
      Significant decrease
    </LegendItem>
    <LegendItem>
      <ArrowUpward fontSize="inherit" sx={{ color: "error.dark" }} />
      <ArrowDownward fontSize="inherit" sx={{ color: "success.dark" }} />
      Change below threshold
    </LegendItem>
    <LegendItem>— No meaningful change</LegendItem>
  </LegendRoot>
);
